"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Notification;
    }
});
const _extractProps = require("~/helpers/extractProps");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _globals = require("~/utils/globals");
const _modelUtils = require("~/utils/modelUtils");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let Notification = class Notification {
    static async insert(notification, ncMeta = _Noco.default.ncMeta) {
        const insertData = (0, _extractProps.extractProps)(notification, [
            'body',
            'type',
            'fk_user_id',
            'is_read',
            'is_deleted'
        ]);
        return await ncMeta.metaInsert2(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.NOTIFICATION, (0, _modelUtils.prepareForDb)(insertData, 'body'));
    }
    static async get(params, ncMeta = _Noco.default.ncMeta) {
        const condition = (0, _extractProps.extractProps)(params, [
            'id',
            'fk_user_id'
        ]);
        return await ncMeta.metaGet2(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.NOTIFICATION, condition);
    }
    static async list(params, ncMeta = _Noco.default.ncMeta) {
        const { limit = 10, offset = 0 } = params;
        const condition = (0, _extractProps.extractProps)(params, [
            'is_read',
            'is_deleted',
            'fk_user_id'
        ]);
        const notifications = await ncMeta.metaList2(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.NOTIFICATION, {
            condition,
            limit,
            offset,
            orderBy: {
                created_at: 'desc'
            }
        });
        for (const notification of notifications){
            (0, _modelUtils.prepareForResponse)(notification, 'body');
        }
        return notifications;
    }
    static async count(params, ncMeta = _Noco.default.ncMeta) {
        const condition = (0, _extractProps.extractProps)(params, [
            'is_read',
            'is_deleted',
            'fk_user_id'
        ]);
        const count = await ncMeta.metaCount(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.NOTIFICATION, {
            condition
        });
        return count;
    }
    static async update(id, notification, ncMeta = _Noco.default.ncMeta) {
        const updateData = (0, _extractProps.extractProps)(notification, [
            'body',
            'type',
            'fk_user_id',
            'is_read',
            'is_deleted'
        ]);
        return await ncMeta.metaUpdate(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.NOTIFICATION, (0, _modelUtils.prepareForDb)(updateData, 'body'), id);
    }
    static async markAllAsRead(fk_user_id, ncMeta = _Noco.default.ncMeta) {
        return ncMeta.metaUpdate(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.NOTIFICATION, {
            is_read: true
        }, {
            fk_user_id,
            is_read: false
        });
    }
    constructor(notification){
        Object.assign(this, notification);
    }
};
